import { BoxStaffLightDto, BoxStaffRole } from "@modules/boxStaff/gateway/boxStaffDto"
import { convertUserFromDto } from "@modules/profile/profileDtos"
import { User } from "@modules/profile/profileTypes"
export type BoxStaffLightState = Omit<BoxStaffLightEntity, "convertToUser" | "getUserName">

export class BoxStaffLightEntity {
  staffMemberId: string
  staffMemberRole: BoxStaffRole
  user: User

  private constructor(boxStaffLightEntity: BoxStaffLightState) {
    this.staffMemberId = boxStaffLightEntity.staffMemberId
    this.staffMemberRole = boxStaffLightEntity.staffMemberRole
    this.user = boxStaffLightEntity.user
  }

  static fromDto(dto: BoxStaffLightDto): BoxStaffLightEntity {
    return new BoxStaffLightEntity({
      staffMemberId: dto.staffMemberId,
      staffMemberRole: dto.staffMemberRole,
      user: convertUserFromDto(dto.user),
    })
  }

  getUserName(): string {
    if (this.user.username === "") {
      return this.user.username
    }
    return "@" + this.user.username
  }
}
